__turbopack_context__.v({
  "blur": "style-module-scss-module__7JM4aW__blur",
  "has-logo": "style-module-scss-module__7JM4aW__has-logo",
  "label": "style-module-scss-module__7JM4aW__label",
  "no-logo": "style-module-scss-module__7JM4aW__no-logo",
});
